import { render, staticRenderFns } from "./FollowDialog.vue?vue&type=template&id=0156638e&scoped=true"
import script from "./FollowDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./FollowDialog.vue?vue&type=script&setup=true&lang=js"
import style0 from "./FollowDialog.vue?vue&type=style&index=0&id=0156638e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0156638e",
  null
  
)

export default component.exports